import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface PlaceholderPageProps {
  title: string;
}

export function PlaceholderPage({ title }: PlaceholderPageProps) {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        {title}
      </Typography>
      <Typography color="text.secondary">Coming soon.</Typography>
    </Box>
  );
}
